import React from 'react';
import { AdminHeader, AdminSidebar } from 'components';
import { MaternityLeaveAllocationForm } from 'components/organisms/MaternityLeaveAllocationForm';

export const MaternityLeaveAllocation = () => {
  return (
    <>
      <AdminHeader />
      <div className="dashboard-wrapper">
        <AdminSidebar />
        <MaternityLeaveAllocationForm />
      </div>
    </>
  );
};
